export const REFRESH_TOKEN_COOKIE_NAME = 'refreshToken';
export const ACCESS_TOKEN_PREFIX = 'Bearer';
export const DEVICE_ID_COOKIE_NAME = 'deviceId';

export enum DeviceType {
	MOBILE = 'mobile',
	DESKTOP = 'desktop',
	TABLET = 'tablet',
}
